import { ViewIcon } from '@chakra-ui/icons';
import { Box, Button, FormControl, IconButton, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, useDisclosure, useToast } from '@chakra-ui/react';
import axios from 'axios';
import React, { useState } from 'react';
import { API_SERVICE } from '../../config';
import { ChatState } from '../../Context/ChatProvider';
import UserBadgeItem from '../UserAvatar/UserBadgeItem';
import UserListItem from '../UserAvatar/UserListItem';

const UpdateGroupChatModal = ({fetchAgain  ,setFetchAgain, fetchMessages}) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [groupChatName , setGroupChatName] = useState();
    const [search , setSearch] = useState("");
    const [searchResult , setSearchResult] = useState([]);
    const [loading , setLoading] = useState(false);
    const [renameloading , setRenameloading] = useState(false);
    const toast = useToast();

    const {user , selectedChat , setSelectedChat} = ChatState();
 
    const handleRemove=async(user1)=>{
      //  console.log(selectedChat.groupAdmin.id);
      //  console.log(user._id)
       if(selectedChat.groupAdmin._id !== user._id && user1._id !== user._id){
        toast({
          title: " Only admins can remove someone! ",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return;
       }
       try {
        setLoading(true);

        const config = {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        };
        const {data} = await axios.put(`${API_SERVICE}/api/chat/groupremove`,{
          chatId:selectedChat._id,
          userId : user1._id
        } , config);
        
        user1._id === user._id ? setSelectedChat() : setSelectedChat(data); //if a user has left the group , then the group chat must be removed from its chat.
        fetchMessages();
        setLoading(false);
        setFetchAgain(!fetchAgain);
        
       } catch (error) {
        toast({
          title: " Error Occured! ",
          description:error.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setLoading(false);
       }
    }
  
    const handleAddUser=async(user1)=>{
      if(selectedChat.users.find((u)=>u._id===user1._id))
      {toast({
        title: " User already added! ",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      return;
    }
      if(selectedChat.groupAdmin._id !== user._id){
        toast({
          title: " Only admins can add someone! ",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return;
      }

      try {
        setLoading(true);

        const config = {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        };
        const {data} = await axios.put(`${API_SERVICE}/api/chat/groupadd`,{
          chatId:selectedChat._id,
          userId : user1._id
        } , config);
        setSelectedChat(data);
        setLoading(false);
        setFetchAgain(!fetchAgain);
        
      } catch (error) {
        toast({
          title: "Error Occured!",
          description:error.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setLoading(false);
      }

    }
    const handleRename = async () => {
      if (!groupChatName) return;
  
      try {
        setRenameloading(true);
        const config = {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        };
        const { data } = await axios.put(
          `${API_SERVICE}/api/chat/rename`,
          {
            chatId: selectedChat._id,
            chatName: groupChatName,
          },
          config
        );
        console.log(selectedChat.chatName);
        console.log(data._id);
        // setSelectedChat("");
        setSelectedChat(data);
        //setFetchAgain(!fetchAgain);
        setRenameloading(false);
      } catch (error) {
        toast({
          title: "Error Occured!",
          description: error.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setRenameloading(false);
      }
      setGroupChatName("");
    };
    const handleSearch=async(query)=>{
      setSearch(query);
      if(!query) return;
      try {
         setLoading(true);

         const config={
             headers:{
                 Authorization:`Bearer ${user.token}`,     
             }
         }
         const {data} = await axios.get(`${API_SERVICE}/api/user?search=${search}` , config); 
        //  console.log(data);
          setLoading(false);
          setSearchResult(data);
     } catch (err) {
         toast({
             title: "Error!",
             description: "Failed to Load the Search Results",
             status: "error",
             duration: 5000,
             isClosable: true,
             position: "bottom-left",
           });
      }
 };

    return (
        <>
      <IconButton display={{base:"flex"}} icon={<ViewIcon/>} onClick={onOpen}/>
      
     <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
          alignItems={"center"}
          display="flex"
          justifyContent={"center"}
          fontFamily="Work sans"
          fontSize="35px"
          >{selectedChat.chatName}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box w="100%" display="flex" flexWrap={"wrap"} pb={3}>
                {selectedChat.users.map(u=>(
                    <UserBadgeItem key={user._Id} user={u}
                    handleFunction={()=>handleRemove(u)}
                    />
                ))}
            </Box>
            <FormControl display={"flex"}>
                <Input
                placeholder='Chat Name'
                mb={3}
                value={groupChatName}
                onChange={(e)=>setGroupChatName(e.target.value)}
                />
                <Button
                varient="solid"
                colorScheme="teal"
                ml={1}
                isLoading={renameloading}
                onClick={handleRename}
                >
                    Update
                </Button>
            </FormControl>
            <FormControl>
                    <Input placeholder="Add User to group"               
                     mb={1}                                               
                     onChange={(e)=> handleSearch(e.target.value)}
                    />
            </FormControl>
            {loading?
             <Spinner size={"lg"}/>
            :(
                     searchResult?.slice(0,4).map((user)=> (
                     <UserListItem key={user._id} user={user} handleFunction={()=> handleAddUser(user)}/>
                  )
                ))}
                
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='red'  onClick={()=> handleRemove(user)}>
              Leave Group
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
    );
};

export default UpdateGroupChatModal;